import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, Col, Row, Button, Form, Modal, Badge } from "react-bootstrap";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";

import img1 from "../assets/img/img1.jpg";

export default function Profile() {
  const [showEditModal, setShowEditModal] = useState(false);
  const [profileData, setProfileData] = useState({
    name: "Administrateur Principal",
    title: "Super Admin Plateforme Fiscale",
    location: "Paris, Centre National des Impôts",
    bio: "Administrateur principal de la plateforme de gestion fiscale. Responsable de la supervision des opérations, gestion des utilisateurs et maintenance du système.",
    role: "SUPER_ADMIN",
    department: "Direction des Systèmes d'Information",
    employeeId: "ADMIN-001",
    dateJoined: "15/01/2020",
    lastLogin: "Aujourd'hui, 09:45",
    status: "Actif",
    permissions: ["Tous les droits", "Gestion complète", "Audit système"],
    certificates: 8,
    experience: "4+ années",
    usersManaged: 1250,
    activeSessions: 42,
    contact: {
      workAddress: "Centre National des Impôts, 120 Rue de Rivoli, 75001 Paris",
      phone: "+33 1 40 15 40 15",
      email: "admin@plateforme-fiscale.gouv.fr",
      emergencyContact: "+33 6 12 34 56 78"
    },
    system: {
      accessLevel: "Niveau 5 - Accès complet",
      twoFactorEnabled: true,
      lastSecurityAudit: "10/04/2024",
      apiAccess: true
    }
  });

  const [editForm, setEditForm] = useState({ ...profileData });

  const handleShowEditModal = () => {
    setEditForm({ ...profileData });
    setShowEditModal(true);
  };

  const handleSaveProfile = () => {
    setProfileData({ ...editForm });
    setShowEditModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setEditForm(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setEditForm(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  return (
    <React.Fragment>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <Row className="g-5">
          <Col xl={8}>
            <div className="media-profile mb-5">
              <div className="media-img mb-3 mb-sm-0 position-relative">
                <img src={img1} className="img-fluid rounded-circle" alt="Photo admin" style={{width: '150px', height: '150px', objectFit: 'cover'}} />
                <Badge bg="danger" className="position-absolute top-0 end-0 mt-2 me-2">
                  <i className="ri-shield-keyhole-line me-1"></i> Super Admin
                </Badge>
              </div>
              <div className="media-body">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <h5 className="media-name">{profileData.name}</h5>
                    <p className="text-primary mb-2">{profileData.title}</p>
                    <p className="d-flex gap-2 mb-3">
                      <i className="ri-building-line"></i> {profileData.location}
                    </p>
                    <p className="mb-3">{profileData.bio}</p>
                  </div>
                  <Button 
                    variant="outline-primary" 
                    size="sm"
                    onClick={handleShowEditModal}
                  >
                    <i className="ri-edit-line me-1"></i> Modifier profil
                  </Button>
                </div>
                
                <div className="mt-4">
                  <h6 className="mb-3">Informations Administratives</h6>
                  <Row className="g-3">
                    <Col md={6}>
                      <div className="d-flex align-items-center mb-2">
                        <i className="ri-user-settings-line me-2 text-primary"></i>
                        <span className="fw-semibold">Rôle:</span>
                        <Badge bg="dark" className="ms-2">{profileData.role}</Badge>
                      </div>
                      <div className="d-flex align-items-center mb-2">
                        <i className="ri-organization-chart me-2 text-primary"></i>
                        <span className="fw-semibold">Département:</span>
                        <span className="ms-2">{profileData.department}</span>
                      </div>
                      <div className="d-flex align-items-center mb-2">
                        <i className="ri-id-card-line me-2 text-primary"></i>
                        <span className="fw-semibold">ID Employé:</span>
                        <span className="ms-2">{profileData.employeeId}</span>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="d-flex align-items-center mb-2">
                        <i className="ri-calendar-event-line me-2 text-primary"></i>
                        <span className="fw-semibold">Date d'entrée:</span>
                        <span className="ms-2">{profileData.dateJoined}</span>
                      </div>
                      <div className="d-flex align-items-center mb-2">
                        <i className="ri-login-circle-line me-2 text-primary"></i>
                        <span className="fw-semibold">Dernière connexion:</span>
                        <span className="ms-2">{profileData.lastLogin}</span>
                      </div>
                      <div className="d-flex align-items-center mb-2">
                        <i className="ri-checkbox-circle-line me-2 text-success"></i>
                        <span className="fw-semibold">Statut:</span>
                        <span className="ms-2">{profileData.status}</span>
                      </div>
                    </Col>
                  </Row>
                  
                  <div className="mt-3">
                    <h6 className="mb-2">Permissions Système</h6>
                    <div className="d-flex flex-wrap gap-2">
                      {profileData.permissions.map((permission, index) => (
                        <Badge key={index} bg="info" className="py-2 px-3">
                          <i className="ri-shield-check-line me-1"></i> {permission}
                        </Badge>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Row className="row-cols-sm-auto g-4 g-md-5 g-xl-4 g-xxl-5">
              {[
                // {
                //   "icon": "ri-shield-star-line",
                //   "text": `${profileData.certificates} Certifications`,
                //   "label": "Sécurité & Administration",
                //   "color": "text-danger"
                // }, 
                
                {
                  "icon": "ri-briefcase-line",
                  "text": profileData.experience,
                  "label": "Expérience Admin",
                  "color": "text-primary"
                }, {
                  "icon": "ri-user-line",
                  "text": profileData.usersManaged,
                  "label": "Utilisateurs gérés",
                  "color": "text-success"
                }, {
                  "icon": "ri-computer-line",
                  "text": profileData.activeSessions,
                  "label": "Sessions actives",
                  "color": "text-warning"
                }
              ].map((profileItem, index) => (
                <Col key={index}>
                  <Card className="border-0 shadow-sm">
                    <Card.Body className="py-3">
                      <div className="d-flex align-items-center">
                        <div className={`bg-light rounded-circle p-3 me-3 ${profileItem.color}`}>
                          <i className={`${profileItem.icon} fs-4`}></i>
                        </div>
                        <div>
                          <h5 className="mb-0 fw-bold">{profileItem.text}</h5>
                          <span className="text-muted small">{profileItem.label}</span>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            <Card className="card-post mt-4">
              <Card.Header className="d-flex justify-content-between align-items-center">
                <Card.Title>Statistiques de la Plateforme</Card.Title>
                <Link to="/dashboard-admin" className="btn btn-sm btn-outline-primary">
                  Tableau de bord complet
                </Link>
              </Card.Header>
              <Card.Body>
                <Row className="g-4">
                  <Col md={6}>
                    <div className="d-flex align-items-center p-3 bg-light rounded">
                      <div className="bg-primary rounded-circle p-3 me-3">
                        <i className="ri-user-add-line text-white fs-4"></i>
                      </div>
                      <div>
                        <h5 className="mb-0">1,250</h5>
                        <p className="mb-0 text-muted">Utilisateurs totaux</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex align-items-center p-3 bg-light rounded">
                      <div className="bg-success rounded-circle p-3 me-3">
                        <i className="ri-file-text-line text-white fs-4"></i>
                      </div>
                      <div>
                        <h5 className="mb-0">8,542</h5>
                        <p className="mb-0 text-muted">Déclarations traitées</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex align-items-center p-3 bg-light rounded">
                      <div className="bg-warning rounded-circle p-3 me-3">
                        <i className="ri-euro-circle-line text-white fs-4"></i>
                      </div>
                      <div>
                        <h5 className="mb-0">€12.8M</h5>
                        <p className="mb-0 text-muted">Recettes collectées</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex align-items-center p-3 bg-light rounded">
                      <div className="bg-info rounded-circle p-3 me-3">
                        <i className="ri-server-line text-white fs-4"></i>
                      </div>
                      <div>
                        <h5 className="mb-0">99.8%</h5>
                        <p className="mb-0 text-muted">Disponibilité système</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <Card className="card-post mt-4">
              <Card.Header className="d-flex justify-content-between align-items-center">
                <Card.Title>Alertes Système Récentes</Card.Title>
                <Badge bg="danger" pill>3 nouvelles</Badge>
              </Card.Header>
              <Card.Body>
                <div className="list-group">
                  <div className="list-group-item border-0 d-flex align-items-start">
                    <div className="bg-danger bg-opacity-10 rounded-circle p-2 me-3">
                      <i className="ri-alarm-warning-line text-danger"></i>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mb-1">Tentative de connexion suspecte</h6>
                      <small className="text-muted">IP: 192.168.1.100 - Il y a 2 heures</small>
                      <p className="mb-0 small">Plusieurs tentatives échouées depuis une IP non autorisée</p>
                    </div>
                    <Button variant="outline-danger" size="sm">Bloquer IP</Button>
                  </div>
                  <div className="list-group-item border-0 d-flex align-items-start">
                    <div className="bg-warning bg-opacity-10 rounded-circle p-2 me-3">
                      <i className="ri-database-2-line text-warning"></i>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mb-1">Espace disque critique</h6>
                      <small className="text-muted">Serveur principal - Il y a 4 heures</small>
                      <p className="mb-0 small">85% de l'espace disque utilisé sur /var/lib</p>
                    </div>
                    <Button variant="outline-warning" size="sm">Nettoyer</Button>
                  </div>
                  <div className="list-group-item border-0 d-flex align-items-start">
                    <div className="bg-info bg-opacity-10 rounded-circle p-2 me-3">
                      <i className="ri-time-line text-info"></i>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mb-1">Sauvegarde hebdomadaire terminée</h6>
                      <small className="text-muted">Hier, 02:00</small>
                      <p className="mb-0 small">Sauvegarde de 45.2GB complétée avec succès</p>
                    </div>
                    <Button variant="outline-info" size="sm">Vérifier</Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          
          <Col xl={4}>
            <Card className="mb-4">
              <Card.Header className="d-flex justify-content-between align-items-center">
                <Card.Title>Informations Système</Card.Title>
                <Button 
                  variant="link" 
                  size="sm"
                  onClick={handleShowEditModal}
                >
                  <i className="ri-edit-line"></i>
                </Button>
              </Card.Header>
              <Card.Body>
                <ul className="list-contact-info">
                  <li>
                    <i className="ri-shield-keyhole-line text-danger"></i>
                    <span>Niveau d'accès: {profileData.system.accessLevel}</span>
                  </li>
                  <li>
                    <i className="ri-shield-check-line text-success"></i>
                    <span>
                      Authentification à deux facteurs: 
                      {profileData.system.twoFactorEnabled ? 
                        <Badge bg="success" className="ms-2">Activée</Badge> : 
                        <Badge bg="secondary" className="ms-2">Désactivée</Badge>
                      }
                    </span>
                  </li>
                  <li>
                    <i className="ri-file-search-line text-info"></i>
                    <span>Dernier audit sécurité: {profileData.system.lastSecurityAudit}</span>
                  </li>
                  <li>
                    <i className="ri-api-line text-primary"></i>
                    <span>
                      Accès API: 
                      {profileData.system.apiAccess ? 
                        <Badge bg="primary" className="ms-2">Autorisé</Badge> : 
                        <Badge bg="secondary" className="ms-2">Restreint</Badge>
                      }
                    </span>
                  </li>
                </ul>
              </Card.Body>
            </Card>

            <Card className="mb-4">
              <Card.Header className="d-flex justify-content-between align-items-center">
                <Card.Title>Contact d'Urgence</Card.Title>
                <Button 
                  variant="link" 
                  size="sm"
                  onClick={handleShowEditModal}
                >
                  <i className="ri-edit-line"></i>
                </Button>
              </Card.Header>
              <Card.Body>
                <ul className="list-contact-info">
                  <li>
                    <i className="ri-building-3-line text-primary"></i>
                    <span>{profileData.contact.workAddress}</span>
                  </li>
                  <li>
                    <i className="ri-phone-line text-primary"></i>
                    <span>{profileData.contact.phone}</span>
                  </li>
                  <li>
                    <i className="ri-mail-line text-primary"></i>
                    <span>{profileData.contact.email}</span>
                  </li>
                  <li>
                    <i className="ri-alarm-warning-line text-danger"></i>
                    <span>Contact urgence: {profileData.contact.emergencyContact}</span>
                  </li>
                </ul>
              </Card.Body>
            </Card>

            <Card className="mb-4">
              <Card.Header>
                <Card.Title>Actions Rapides Admin</Card.Title>
              </Card.Header>
              <Card.Body>
                <div className="d-grid gap-2">
                  <Button variant="outline-primary" className="text-start">
                    <i className="ri-user-settings-line me-2"></i>
                    Gérer les utilisateurs
                  </Button>
                  <Button variant="outline-success" className="text-start">
                    <i className="ri-dashboard-line me-2"></i>
                    Tableau de bord système
                  </Button>
                  <Button variant="outline-warning" className="text-start">
                    <i className="ri-file-search-line me-2"></i>
                    Voir les logs système
                  </Button>
                  <Button variant="outline-info" className="text-start">
                    <i className="ri-settings-3-line me-2"></i>
                    Paramètres avancés
                  </Button>
                  <Button variant="outline-danger" className="text-start">
                    <i className="ri-shield-keyhole-line me-2"></i>
                    Gestion des permissions
                  </Button>
                </div>
              </Card.Body>
            </Card>

            <Card>
              <Card.Header>
                <Card.Title>Dernières Activités Admin</Card.Title>
              </Card.Header>
              <Card.Body>
                <div className="list-group">
                  <div className="list-group-item border-0">
                    <small className="text-muted">Il y a 30 min</small>
                    <p className="mb-1">Modification des droits utilisateur pour "Agence Paris Centre"</p>
                  </div>
                  <div className="list-group-item border-0">
                    <small className="text-muted">Il y a 2 heures</small>
                    <p className="mb-1">Redémarrage du service de base de données</p>
                  </div>
                  <div className="list-group-item border-0">
                    <small className="text-muted">Aujourd'hui, 08:15</small>
                    <p className="mb-1">Génération du rapport quotidien système</p>
                  </div>
                  <div className="list-group-item border-0">
                    <small className="text-muted">Hier, 22:30</small>
                    <p className="mb-1">Mise à jour des règles de sécurité</p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Footer />

        {/* Modal d'édition du profil admin */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="ri-shield-keyhole-line me-2"></i>
              Modifier le profil Administrateur
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <h6 className="mb-3">Informations Personnelles</h6>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nom complet</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={editForm.name}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Titre</Form.Label>
                    <Form.Control
                      type="text"
                      name="title"
                      value={editForm.title}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Localisation</Form.Label>
                    <Form.Control
                      type="text"
                      name="location"
                      value={editForm.location}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="bio"
                      value={editForm.bio}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <h6 className="mb-3 mt-4">Informations Administratives</h6>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>ID Employé</Form.Label>
                    <Form.Control
                      type="text"
                      name="employeeId"
                      value={editForm.employeeId}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Département</Form.Label>
                    <Form.Control
                      type="text"
                      name="department"
                      value={editForm.department}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Date d'entrée</Form.Label>
                    <Form.Control
                      type="text"
                      name="dateJoined"
                      value={editForm.dateJoined}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Statut</Form.Label>
                    <Form.Select
                      name="status"
                      value={editForm.status}
                      onChange={handleInputChange}
                    >
                      <option value="Actif">Actif</option>
                      <option value="Inactif">Inactif</option>
                      <option value="Vacances">Vacances</option>
                      <option value="Formation">Formation</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <h6 className="mb-3 mt-4">Coordonnées</h6>
              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Adresse professionnelle</Form.Label>
                    <Form.Control
                      type="text"
                      name="contact.workAddress"
                      value={editForm.contact.workAddress}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Téléphone professionnel</Form.Label>
                    <Form.Control
                      type="text"
                      name="contact.phone"
                      value={editForm.contact.phone}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email professionnel</Form.Label>
                    <Form.Control
                      type="email"
                      name="contact.email"
                      value={editForm.contact.email}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Contact d'urgence</Form.Label>
                    <Form.Control
                      type="text"
                      name="contact.emergencyContact"
                      value={editForm.contact.emergencyContact}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <h6 className="mb-3 mt-4">Paramètres Système</h6>
              <Row>
                {/* <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Niveau d'accès</Form.Label>
                    <Form.Select
                      name="system.accessLevel"
                      value={editForm.system.accessLevel}
                      onChange={handleInputChange}
                    >
                      <option value="Niveau 5 - Accès complet">Niveau 5 - Accès complet</option>
                      <option value="Niveau 4 - Accès élevé">Niveau 4 - Accès élevé</option>
                      <option value="Niveau 3 - Accès standard">Niveau 3 - Accès standard</option>
                    </Form.Select>
                  </Form.Group>
                </Col> */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="switch"
                      id="twoFactorEnabled"
                      label="Authentification à deux facteurs"
                      name="system.twoFactorEnabled"
                      checked={editForm.system.twoFactorEnabled}
                      onChange={(e) => setEditForm(prev => ({
                        ...prev,
                        system: {
                          ...prev.system,
                          twoFactorEnabled: e.target.checked
                        }
                      }))}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="switch"
                      id="apiAccess"
                      label="Accès API"
                      name="system.apiAccess"
                      checked={editForm.system.apiAccess}
                      onChange={(e) => setEditForm(prev => ({
                        ...prev,
                        system: {
                          ...prev.system,
                          apiAccess: e.target.checked
                        }
                      }))}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Annuler
            </Button>
            <Button variant="primary" onClick={handleSaveProfile}>
              <i className="ri-save-line me-1"></i>
              Enregistrer les modifications
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
}